import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowLeft } from "lucide-react";
import CTABanner from "../components/CTABanner";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api
      .get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="pt-40 pb-20 max-w-3xl mx-auto px-6 text-center" data-testid="blog-not-found">
        <h1 className="font-display font-black text-5xl tracking-tighter">Not found</h1>
        <Link to="/blog" className="mt-6 inline-block underline">Back to insights</Link>
      </div>
    );
  }

  if (!post) {
    return <div className="pt-40 pb-20 text-center text-[#4B5668]">Loading…</div>;
  }

  return (
    <div data-testid="blog-detail-page">
      <section className="relative pt-40 pb-16 bg-[#0A1F3F] text-white overflow-hidden">
        <img src={post.image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-black/90" />
        <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-12">
          <Link to="/blog" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-white/70 hover:text-white" data-testid="blog-back-link">
            <ArrowLeft className="w-4 h-4" /> Back to insights
          </Link>
          <div className="text-eyebrow text-[#F37021] mt-6">{post.category}</div>
          <h1 className="mt-5 font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.98]">
            {post.title}
          </h1>
          <div className="mt-8 flex items-center gap-4 text-xs uppercase tracking-[0.18em] text-white/70">
            <span>{post.author}</span>
            <span className="w-1 h-1 bg-white/60 rounded-full" />
            <span>{post.published_at}</span>
            <span className="w-1 h-1 bg-white/60 rounded-full" />
            <span>{post.read_minutes} min read</span>
          </div>
        </div>
      </section>

      <article className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-12 text-lg leading-[1.8] text-[#0A1F3F] whitespace-pre-line">
          {post.content}
        </div>
      </article>

      <CTABanner />
    </div>
  );
}
